import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../../hooks';
import { USER_ROLE_ENUM } from '../../../interfaces';
import Spinner from '../../shared/spinner';

const Profile = lazy(() => import('./profile'));
const MyPurchases = lazy(() => import('./purchases'));
const Wishlist = lazy(() => import('./wishlist'));
const Invoice = lazy(() => import('../../shared/invoice'));

const User = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      window.location.href = '/';
    } else if (user && user.role !== USER_ROLE_ENUM.user) {
      navigate(`/${user.role}/profile`);
    }
  }, []);

  return (
    <Suspense fallback={<Spinner text={'Loading...'}
                                 style={{ padding: '100px' }}/>}>
      <Routes>
        <Route path={'profile'} element={<Profile/>}/>
        <Route path={'purchases'} element={<MyPurchases/>}/>
        <Route path={'purchases/invoice/:purchaseID'} element={<Invoice/>}/>
        <Route path={'wishlist'} element={<Wishlist/>}/>
        <Route path={'*'} element={<Navigate to={'/not/found'}/>}/>
      </Routes>
    </Suspense>
  );
}

export default User;